<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <LogRightDialog ref="logRightDialog" busiCode="imp100041" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'orderId'"
                  @click="toOrderIdDetail(scope.row.orderId)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-if="scope.column.property === 'plateNumber'"
                  @click="toCarDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-if="
                    scope.column.property !== 'orderId' &&
                    scope.column.property !== 'plateNumber'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions
                  permpisions="10030401"
                  v-if="scope.row.state === 3"
                >
                  <span
                    class="primary cur"
                    @click="toDetail(scope.row, 'approve')"
                    >审核</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="toDetail(scope.row)"
                    >查看</span
                  >
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  repostCostApproveList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orderId', label: '订单号', fixed: true },
          { prop: 'dependTime', label: '发车时间' },
          { prop: 'sourceName', label: '线路名称' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'userName', label: '司机姓名' },
          { prop: 'linkPhone', label: '司机手机号' },
          { prop: 'subTime', label: '提交时间' },
          { prop: 'subUserName', label: '提交人' },
          { prop: 'stateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: repostCostApproveList,
    toOrderIdDetail (orderId) {
      this.jump({
        label: `订单详情-${orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${orderId}`,
        full: true,
      });
    },
    toCarDetail (item) {
      this.jump({
        label: `查看车辆${item.plateNumber ? ('-' + item.plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?plateNumber=${encodeURIComponent(item.plateNumber)}`,
        full: true,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核上报费用' : '上报费用详情',
        url: `/manage/cost/report/approve/detail?id=${item.id}&orderId=${item.orderId}&type=${type}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
